import { render } from "./childrenPrivacy.vue?vue&type=template&id=f2eebde6"
const script = {}

import "./childrenPrivacy.vue?vue&type=style&index=0&id=f2eebde6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__